import Vue from "vue";
import Vuex from "vuex";
// import Cookies from "js-cookie";
import { getToken as getWxToken } from "@/api/wx";

Vue.use(Vuex);
const TOKEN = "token";
const PROJECTID = "projectId";
// const cookieTime = 7;
let TOKEN_VALUE;
let KEY_VALUE;
const bearer = "781d8dce-da11-4b6b-b293-b9381feccf7e";
if (process.env.NODE_ENV === "development") {
	TOKEN_VALUE = bearer;
	KEY_VALUE = "room";
} else {
	TOKEN_VALUE = localStorage.getItem(TOKEN);
	KEY_VALUE = localStorage.getItem(PROJECTID);
}
export default new Vuex.Store({
	state: {
		token: TOKEN_VALUE,
		key: KEY_VALUE,
		loading: false,
	},
	getters: {
		getToken: state => {
			return state.token;
		},
	},
	mutations: {
		SET_TOKEN(state, token) {
			state.token = token;
			/* Cookies.set(TOKEN, token, {
				expires: cookieTime,
			}); */
			localStorage.setItem(TOKEN, token);
		},
		SET_PROJECTID(state, projectId) {
			state.key = projectId;
			/* Cookies.set(PROJECTID, projectId, {
				expires: cookieTime,
			}); */
			localStorage.setItem(PROJECTID, projectId);
		},
		REMOVE_TOKEN() {
			localStorage.removeItem(TOKEN);
			// Cookies.remove(TOKEN);
		},
	},
	actions: {
		setProjectId({ commit }, key) {
			commit("SET_PROJECTID", key);
		},
		getTokenByCode({ commit, }, param) {
			return new Promise((resolve, reject) => {
				getWxToken({
					code: param.code,
					modulesUuid: param.projectId,
				}).then(res => {
					commit("SET_TOKEN", res.data);
					commit("SET_PROJECTID", param.projectId);
					resolve();
				})
					.catch(err => {
						reject(err);
					});
			});
		},
	},
});
